module.exports = __webpack_public_path__ + "static/media/screenshot2.40b40ffe.png";